import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Nav = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  return (
    <>
      <nav
        className="navbar sticky-top shadow"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="nav-container">
          <NavLink to="/" className="nav-logo mx-5">
            Co-Resources
          </NavLink>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                to="/"
                className="nav-links active"
                onClick={click ? handleClick : null}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/coaching"
                className="nav-links active"
                onClick={click ? handleClick : null}
              >
                Coachings
              </NavLink>
            </li>
          </ul>
          <div className="nav-icon pt-2 mt-1" onClick={handleClick}>
            <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Nav;
